import { render } from "./SmallPatientCard.vue?vue&type=template&id=5a329905"
import script from "./SmallPatientCard.vue?vue&type=script&lang=js"
export * from "./SmallPatientCard.vue?vue&type=script&lang=js"

import "./SmallPatientCard.vue?vue&type=style&index=0&id=5a329905&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__